// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Navbar Scroll

jQuery(document).ready(function($) {

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 400) {
      $('.cwu-navbar').addClass('cwu-navbar-scroll');
    }
    else {
      $('.cwu-navbar').removeClass('cwu-navbar-scroll');
    }
  });
});

// http://webdesignerwall.com/tutorials/animated-scroll-to-top

$(document).ready(function(){

  // hide #up-nav first
  $('#up-nav').hide();
  
  // fade in #up-nav
  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#up-nav').fadeIn();
      } else {
        $('#up-nav').fadeOut();
      }
    });

    // scroll body to 0px on click
    $('#up-nav a').click(function () {
      $('body,html').animate({
        scrollTop: 0,
      }, 800);
      return false;
    });
  });

  $('#search-icon').click(function() {
    $(this).toggleClass('active');
    $('#searchbar').toggleClass('open');
  });

  $('#toggle').click(function() {
    $(this).toggleClass('active');
    $('#overlay').toggleClass('open');
  });

});

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebookSquare, faTwitter } from '@fortawesome/free-brands-svg-icons';
// import the Facebook and Twitter icons
import { faSearch, faChevronUp, faLock } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faFacebookSquare, faTwitter, faSearch, faChevronUp, faLock);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();




// WEBPACK FOOTER //
// ./scripts/main.js